import { Suspense, useMemo } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes } from "react-router-dom";
import { StaticRouter } from "react-router-dom/server";
import { usePageContext } from "vike-react/usePageContext";
import { store } from "../../src/store/store";
import ServicesPage from "../../src/pages/services";
import RouteLoadingFallback from "../../src/shared/RouteLoadingFallback";
import SiteDocumentTitleSync from "../../src/components/common/SiteDocumentTitleSync";
import {
  createPublicRoutes,
  renderAppMainRoutes,
} from "../../src/router/appMainRoutes";
import { PATHS } from "../../src/shared/publicPaths";

export default function ServicesListPage() {
  const pageContext = usePageContext();
  const isServer = typeof window === "undefined";
  const location = pageContext.urlPathname || PATHS.services;
  const pageProps = (pageContext as { pageProps?: { initialCategories?: any[] } })
    .pageProps || {};

  const publicRoutes = useMemo(
    () =>
      createPublicRoutes({
        servicesList: (
          <ServicesPage initialCategories={pageProps.initialCategories} />
        ),
      }),
    [pageProps.initialCategories]
  );

  const tree = (
    <Suspense fallback={<RouteLoadingFallback />}>
      <SiteDocumentTitleSync />
      <Routes>{renderAppMainRoutes({ publicRoutes })}</Routes>
    </Suspense>
  );

  return (
    <Provider store={store}>
      {isServer ? (
        <StaticRouter location={location}>{tree}</StaticRouter>
      ) : (
        <BrowserRouter>{tree}</BrowserRouter>
      )}
    </Provider>
  );
}
